import { call, put, takeLatest } from 'redux-saga/effects';
import { myautoiqTemplateGenerationSettingsActions } from 'app/pages/MyautoiqTemplateGenerationSettingsComponent/slice';
import {
  fetchMyautoiqTemplateGenerationSettings,
  updateMyautoiqTemplateGenerationSettings,
} from './data/myautoiqTemplateGenerationSettingsDataService';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';

function* fetchMyautoiqTemplateGenerationSettingsSaga(action: ReturnType<any>) {
  try {
    const response = yield call(fetchMyautoiqTemplateGenerationSettings, {
      manufacturerId: action.payload.manufacturerId,
    });
    yield put(
      myautoiqTemplateGenerationSettingsActions.requestMyautoiqTemplateGenerationSettingsSuccess(
        response,
      ),
    );
  } catch (error: any) {
    yield put(
      myautoiqTemplateGenerationSettingsActions.requestMyautoiqTemplateGenerationSettingsError(
        error?.message || 'Failed to fetch',
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Myautoiq template generation settings fetch failed',
      }),
    );
  }
}

function* updateMyautoiqTemplateGenerationSettingsSaga(action: ReturnType<any>) {
  try {
    yield call(updateMyautoiqTemplateGenerationSettings, {
      manufacturerId: action.payload.manufacturerId,
      settingsId: action.payload.settingsId,
      data: action.payload.data,
    });
    yield put(
      myautoiqTemplateGenerationSettingsActions.requestUpdateMyautoiqTemplateGenerationSettingsSuccess(),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Myautoiq template generation settings updated successfully',
      }),
    );
    yield put(
      myautoiqTemplateGenerationSettingsActions.requestMyautoiqTemplateGenerationSettings({
        manufacturerId: action.payload.manufacturerId,
      }),
    );
  } catch (error: any) {
    yield put(
      myautoiqTemplateGenerationSettingsActions.requestUpdateMyautoiqTemplateGenerationSettingsError(
        error?.message || 'Failed to update',
      ),
    );
    yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Myautoiq template generation settings update failed',
      }),
    );
  }
}

export function* watchMyautoiqTemplateGenerationSettingsSaga() {
  yield takeLatest(
    myautoiqTemplateGenerationSettingsActions.requestMyautoiqTemplateGenerationSettings.type,
    fetchMyautoiqTemplateGenerationSettingsSaga,
  );
  yield takeLatest(
    myautoiqTemplateGenerationSettingsActions.requestUpdateMyautoiqTemplateGenerationSettings
      .type,
    updateMyautoiqTemplateGenerationSettingsSaga,
  );
}
